export function getCellErrors(groupedErrors, property, index) {
    var _a;
    const errors = ((_a = groupedErrors === null || groupedErrors === void 0 ? void 0 : groupedErrors.get(property)) === null || _a === void 0 ? void 0 : _a.get(index.toString())) || [];
    const hasError = errors.length > 0;
    return { hasError, errors };
}
